import styled from 'styled-components';
import HappyOyoSvg from './happyOyo.svg';

const HappyOyoIcon = styled(HappyOyoSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  /* fill: ${props => props.fill || props.theme.colors.ash.base} */
  cursor: pointer;
  g {
    path:first-child {
      fill: ${props =>
        props.fill || props.isActive ? '#ee2e24' : props.theme.colors.downriver.medium};
    }
    path:last-child {
      fill: ${props => props.theme.colors.goWhite.base}
    }
  }
`;

export default HappyOyoIcon;
